import { Eyebrow, Reveal } from "./Reveal";

const POINTS = [
  {
    title: "Business-first thinking",
    description:
      "Requirements are understood from the perspective of business goals and user needs.",
  },
  {
    title: "Development-ready documentation",
    description:
      "Specifications are structured so development teams can execute with greater clarity.",
  },
  {
    title: "Product thinking",
    description:
      "Requirements are connected to user journeys, workflows and product outcomes.",
  },
  {
    title: "Agile approach",
    description:
      "Work is structured around iterative delivery and continuous validation.",
  },
  {
    title: "Single point of coordination",
    description:
      "Business requirements, product definition and delivery support can be coordinated through one engagement.",
  },
];

export default function WhyKaizen() {
  return (
    <section
      id="why-kaizen"
      data-testid="why-kaizen-section"
      className="border-y border-navy/10 bg-white py-24 md:py-32"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <Reveal>
          <Eyebrow>Why Kaizen Labs</Eyebrow>
          <h2 className="mt-5 max-w-2xl font-display text-4xl font-semibold leading-[1.15] tracking-tight md:text-5xl">
            Why businesses work with Kaizen Labs
          </h2>
        </Reveal>
        <div className="mt-14">
          {POINTS.map((point, i) => (
            <Reveal key={point.title} delay={i * 0.05}>
              <div
                data-testid={`why-point-${i}`}
                className={`grid grid-cols-1 gap-3 border-t border-navy/15 py-8 md:grid-cols-12 md:gap-8 ${
                  i === POINTS.length - 1 ? "border-b" : ""
                }`}
              >
                <p className="font-display text-lg text-rust md:col-span-2">
                  {String(i + 1).padStart(2, "0")}
                </p>
                <h3 className="font-display text-2xl font-medium tracking-tight md:col-span-4">
                  {point.title}
                </h3>
                <p className="text-base leading-relaxed text-navy/70 md:col-span-6">
                  {point.description}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
